import { PR_PACKAGES } from 'src/utils/collections/companyLeads';

// Demo company configuration for the Wins Dashboard
// Keys are normalized company names (kebab-case), matching normalizeCompanyName() output
// Lead IDs reference DEMO_USERS: 1 = John Smith, 5 = Julie Anderson
export const DEMO_COMPANY_DATA = {
  seoplus: {
    package: PR_PACKAGES.PREMIUM,
    leadId: 1,
    quotas: { successful: 5, submitted: 8 },
    status: 'onTrack',
  },
  'techvision-inc': {
    package: PR_PACKAGES.PREMIUM,
    leadId: 5,
    quotas: { successful: 4, submitted: 6 },
    status: 'onTrack',
  },
  'greenearth-consulting': {
    package: PR_PACKAGES.ADVANCED,
    leadId: 1,
    quotas: { successful: 2, submitted: 5 },
    status: 'attention',
  },
  'brandcraft-agency': {
    package: PR_PACKAGES.STANDARD,
    leadId: 5,
    quotas: { successful: 1, submitted: 5 },
    status: 'onTrack',
  },
  'retail-growth-strategies': {
    package: PR_PACKAGES.ADVANCED,
    leadId: 1,
    quotas: { successful: 2, submitted: 5 },
    status: 'onTrack',
  },
  'healthtech-pr': {
    package: PR_PACKAGES.PREMIUM,
    leadId: 5,
    quotas: { successful: 5, submitted: 5 },
    status: 'risk',
  },
  'finance-first-advisory': {
    package: PR_PACKAGES.STANDARD,
    leadId: 1,
    quotas: { successful: 1, submitted: 5 },
    status: 'onTrack',
  },
  'hr-excellence-group': {
    package: PR_PACKAGES.LITE,
    leadId: 5,
    quotas: { successful: 1, submitted: 3 },
    status: 'attention',
  },
  'cloud-nine-technologies': {
    package: PR_PACKAGES.ADVANCED,
    leadId: 1,
    quotas: { successful: 2, submitted: 5 },
    status: 'onTrack',
  },
  'social-impact-collective': {
    package: PR_PACKAGES.STANDARD,
    leadId: 5,
    quotas: { successful: 1, submitted: 4 },
    status: 'onTrack',
  },
  'cybersecurity-pros': {
    package: PR_PACKAGES.PREMIUM,
    leadId: 1,
    quotas: { successful: 4, submitted: 6 },
    status: 'onTrack',
  },
  'data-insights-lab': {
    package: PR_PACKAGES.ADVANCED,
    leadId: 5,
    quotas: { successful: 2, submitted: 5 },
    status: 'attention',
  },
  'startup-mentor-ventures': {
    package: PR_PACKAGES.LITE,
    leadId: 1,
    quotas: { successful: 1, submitted: 3 },
    status: 'onTrack',
  },
  'content-first-media': {
    package: PR_PACKAGES.STANDARD,
    leadId: 5,
    quotas: { successful: 1, submitted: 5 },
    status: 'onTrack',
  },
  'luxury-brand-group': {
    package: PR_PACKAGES.ADVANCED,
    leadId: 1,
    quotas: { successful: 3, submitted: 5 },
    status: 'risk',
  },
};
